export enum EGameComponentHooks {
    GameStoreInit = 'onGameStoreInit',
    Init = 'onInit',
    Create = 'onCreate',
    Destroy = 'onDestroy'
}
